import { FiSearch } from "react-icons/fi";
import { useState, useEffect, useMemo } from "react";
import { Button, Card, Form, Table } from "react-bootstrap";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import Swal from "sweetalert2";
import Pagination from "../../../Hooks/Pagination";
import Moment from "react-moment";
import { clientServices } from "../../../APIServices/VoultManagement/clientServices";

const VoultClientManagement = () => {

  const [searchData, setSearchData] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientData, setClientData] = useState("");
  const [clientCount, setClientCount] = useState(0);
  
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("details");
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(clientCount / itemsPerPage);

  const getVaultClients = async () => {
    let data = await clientServices.getVaultClients(
      "all",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setClientList(data?.data || []);
    setClientCount(data?.count || 0);
  };

  const statusUpdateVaultClient = async (userId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status} status of this Client?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const clientData = {
        userId,
        status,
      };
      const data = await clientServices.statusUpdateVaultClient(clientData);
      if (data?.statusCode === 200) {
        getVaultClients();
      }
    });
  };
  
  useEffect(() => {
    getVaultClients();
  }, [searchData, pageNumber, itemsPerPage]);

  const activityLogs = [
    {
      _id: "685fe349e3572b7f40c4253a",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      client: "studyeventformschema",
      activities: "Schema Name have been successfully added to the Schema.",
      updatedValue: "Schema001",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe349e3572b7f40c4253b",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      client: "studyeventformschema",
      activities: "Assign Date have been successfully added to the Schema.",
      updatedValue: "2025-06-18",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42594",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Number",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42595",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENNUM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42596",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259b",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Name",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259c",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENTNAM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259d",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      client: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b2",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V0_SCR",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b3",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b4",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "-30",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b5",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Name have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c2",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V1_D0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c3",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Visit 1 Day 0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c4",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      client: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    }
  ]

  const ClientActivity = useMemo(() => {
    const grouped = {};

    activityLogs.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.client || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        prevoiusValue: item.prevoiusValue,
        updatedValue: item.updatedValue,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [activityLogs]);

  return (
    <div style={{background: "#eee"}}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto ${openPreview ? "shrink" : ""}`} style={{height: "calc(100vh - 71px)"}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {clientCount === 0 ? (
              <NoDataFoundTable MSG="No Clients." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{top: -1}}>
                    <tr>
                      <th style={{width: 45}} className="text-center">Sr.</th>
                      <th>Name</th>
                      <th className="text-center">Total Member</th>
                      <th className="text-center">Setup Password</th>
                      <th className="text-center">Setup Secret Key</th>
                      <th className="text-center">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {clientList.map((item, index) => (
                      <tr
                        key={item.userId}
                        className={ selectedRowId === item.userId ? "selectedRow CP" : "CP"}
                        onClick={() => {
                          setOpenPreview(true);
                          setSelectedRowId(item.userId);
                          setClientData(item);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>
                          <strong>{item.name}</strong>
                          <div className="sub-text">{item.email}</div>
                        </td>
                        <td className="text-center">{item?.totalMember || 0}</td>
                        <td className="text-center">{item?.setupPassword ? "Yes" : "No"}</td>
                        <td className="text-center">{item?.setupSecretKey ? "Yes" : "No"}</td>
                        <td onClick={(e) => {e.stopPropagation(); statusUpdateVaultClient(item?.userId, item?.status === "active" ? "inactive" : "active")}} className={`CP fw-bold text-capitalize text-center ${item?.status === "active" ? "text-success" : "text-danger"}`}>{item?.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={clientCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview">
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                <Button size="sm" variant={ openModule === "details" ? "primary" : "outline-primary"} onClick={() => setOpenModule("details")}>Client Details</Button>
                <Button size="sm" variant={ openModule === "activity" ? "primary" : "outline-primary"} onClick={() => setOpenModule("activity")}>Activity</Button>
              </div>
              <Button size="sm" variant="outline-danger" onClick={() => {setOpenPreview(false)}}>Close</Button>
            </div>
            {openModule === "details" && (
              <>
                <div
                  className="p-3"
                  style={{ height: "calc(100vh - 123px)" }}
                >
                  <Card className="border rounded-2">
                    <Card.Body className="d-flex justify-content-between align-items-center">
                      <div className="summary-item text-center">
                        <span className="label">Total Members</span>
                        <span className="value">
                          {clientData?.totalMember || 0}
                        </span>
                      </div>
                      <div className="divider" />
                      <div className="summary-item text-center">
                        <span className="label">Password Setup</span>
                        <span className={`value ${clientData?.setupPassword ? "text-success" : "text-danger"}`}>
                          {clientData?.setupPassword ? "Yes" : "No"}
                        </span>
                      </div>
                      <div className="divider" />
                      <div className="summary-item text-center">
                        <span className="label">Secret Key Setup</span>
                        <span className={`value ${ clientData?.setupSecretKey ? "text-success" : "text-danger"}`}>
                          {clientData?.setupSecretKey ? "Yes" : "No"}
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </>
            )}
            {openModule === "activity" && (
              <div className="p-2 bg-light overflow-auto" style={{height: "calc(100vh - 123px)"}}>
                {ClientActivity.map(({ data }, index) => (
                  <div key={index}>
                    {data?.map((item, key) => (
                      <div key={key} className="activity__section">
                        <div className="w-100">
                          <p style={{fontSize: 12}} className="m-0">Previous Value : {item?.previousValue}</p>
                          <p style={{fontSize: 12}} className="mb-1">Updated Value : {item?.updatedValue}</p>
                          <ul className="m-0 p-0">
                            <li>
                              <p className="m-0 text-muted" style={{fontSize: 12}}>
                                <span className="text-capitalize" style={{ fontWeight: 600 }}>
                                  {item.type}{": "}
                                </span>
                                {item.activities}
                              </p>
                            </li>
                          </ul>
                          <div className="mt-1 d-flex justify-content-between">
                            <Form.Label className="m-0 text-muted" style={{fontSize: 12}}>
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {item?.createdAt}
                              </Moment>
                            </Form.Label>
                            <Form.Label className="m-0 text-muted" style={{fontSize: 12}}>
                              By: {item?.activityByName}
                            </Form.Label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VoultClientManagement;
